import Link from 'next/link';
import { defaultBreakpoints } from '@/lib/common/breakpoints';
import Slider from '@/components/slider/Slider';
import { getOfferUri } from '@/lib/offer';
import ProductCard from '@/components/category/ProductCard';
import { ProductCarouselProps } from './types';

const ProductCarousel = ({ offers }: ProductCarouselProps) => (
  <div>
    <h2 className="mb-6 flex items-center text-lg font-semibold md:text-xl">
      You May Also Like
    </h2>
    <div className="relative">
      <Slider breakpoints={defaultBreakpoints} speed={300}>
        {offers.map((offer) => (
          <Link href={getOfferUri(offer)} passHref key={offer.sku}>
            <ProductCard offer={offer} />
          </Link>
        ))}
      </Slider>
    </div>
  </div>
);

export default ProductCarousel;
